import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/sales/olshop/";

export function getOlShops() {
  return http.get(apiEndpoint);
}

export function saveOlShop(olShop) {
  return http.post(apiEndpoint);
}
